module.exports = __webpack_public_path__ + "static/media/Maya Hausammann.19e9a08a.png";